var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-offer"
  }, [_c('h3', {
    staticClass: "product-offer__name"
  }, [_vm._v("\n    " + _vm._s(_vm.offer.title) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "product-offer__wrapper"
  }, _vm._l(_vm.offer.list, function (el, index) {
    return _c('label', {
      key: index,
      staticClass: "product-offer__option"
    }, [_c('input', {
      staticClass: "product-offer__default-input",
      attrs: {
        "type": "checkbox",
        "name": el.name,
        "disabled": el.disable
      },
      domProps: {
        "checked": el.value === (_vm.offer.active && _vm.offer.active.value)
      },
      on: {
        "click": function ($event) {
          return _vm.onSelect(el);
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "product-offer__input",
      class: [{
        'product-offer__input_small': _vm.offer.type !== 'color'
      }]
    }, [el.color ? _c('span', {
      staticClass: "product-offer__color",
      style: {
        backgroundColor: el.color
      }
    }) : _c('span', {
      staticClass: "product-offer__text"
    }, [_vm._v(_vm._s(el.name))])])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }